<h3 *ngIf="header" [id]="headerId">{{ header }}</h3>
<h4 *ngIf="label" [id]="labelId">
    <span [innerHTML]="label"></span>
    <span *ngIf="showRequiredIndicator" class="required"> *</span>
</h4>
<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
    <div fxFlex="100" fxLayoutAlign="start center" fxFlex.xs="100" fxFlexFill>
        <span class="radio-checkbox-group" fxFlex="100">
            <mat-radio-group
                [value]="value"
                color="primary"
                (change)="updateRadioGroup($event)"
                [attr.aria-labelledby]="activeHeadingId"
            >
                <ul role="presentation">
                    <li *ngFor="let selection of selections">
                        <mat-radio-button [value]="selection.selectionId">
                            <span class="wrap-mat-radio-checkbox-label">
                                {{ selection.label }}
                            </span>
                        </mat-radio-button>
                    </li>
                </ul>
            </mat-radio-group>
            <mat-error *ngIf="formSubmitted && hasRequiredError">
                {{ requiredMessage }}
            </mat-error>
        </span>
    </div>
</div>
